module.exports = __webpack_public_path__ + "media/application/images/icons/calendar-b5f8e059ff3c42a6d7fcaf669ea50f0e.png";